import React, { Component } from "react";
import "./alarm.less";
import AlarmPage from "./alarmPage/alarmPage";
import DesignView from "../admin/designView/designView";

export default class Alarm extends Component {

  render(){
    return(
      <div className="alarm-container">
        {/* 左侧边栏 */}
        <div className="sidebar1"><AlarmPage/></div>
        {/* 右侧平面图区域 */}
        <div className="content">
          <div className="bg-image" ><DesignView /></div>
        </div>
      </div>
    )
  }
}